import type { managePilots as en } from '@/i18n/locales/en/managePilots';
import type { Translation } from '@/i18n/types';

export const managePilots: Translation<typeof en> = {
  page: {
    title: 'Pilotos',
    lead: 'Todos los pilotos de la plataforma, filtrables por empresa y estado.',
    filterCompany: 'Empresa',
    filterStatus: 'Estado',
    allCompanies: 'Todas las empresas',
    allStatuses: 'Todos los estados',
    empty: 'Ningún piloto coincide con estos filtros.',
    rowsLabel: 'los pilotos',
    company: 'Empresa',
    name: 'Nombre',
    status: 'Estado',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    departments: 'Departamentos',
  },
  status: {
    draft: 'Borrador',
    baseline: 'Medición inicial',
    active: 'Activo',
    interim_review: 'Evaluación intermedia',
    final_review: 'Evaluación final',
    completed: 'Completado',
    scaled: 'Escalado',
  },
};
